import request from '@/router/axios'
import env from '../config/env'

// 获取渠道码列表
export const getChannelCodeList = (data) => {
  // 使用mock数据进行测试
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve(mockChannelCodeList(params))
  //   }, 300)
  // })

  // 实际API调用
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/page`,
    method: 'post',
    data
  })
}

// 获取渠道列表
export const getChannelCodeNameList = (data) => {
  // 使用mock数据进行测试
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve(mockChannelList(params))
  //   }, 300)
  // })

  // 实际API调用
  return request({
    // url: 'http://192.168.31.207:37579/channelManage/channelNameList',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/channelNameList`,
    method: 'post',
    data
  })
}

// 添加渠道
export const addChannel = (data) => {
  return request({
    // url: 'http://192.168.31.207:37579/channelManage/edit',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/edit`,
    method: 'post',
    data
  })
}

// 新增应用端
export const addClient = (data) => {
  console.log('params', data)
  return request({
    // url: 'http://192.168.31.207:37579/channelManage/client/edit',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/client/edit`,
    method: 'post',
    data
  })
}

// 删除渠道
export const deleteChannel = (id) => {
  return request({
    // url: `http://192.168.31.207:37579/channelManage/delete/${id}`,
    // 发布配置
    url: `${env.ferryUrl}/channelManage/delete/${id}`,
    method: 'delete'
  })
}

// 获取日志列表
export const getLogList = (data) => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/op/log/page`,
    method: 'post',
    data
  })
}

// 获取渠道码税率
export const getTaxRateInfo = () => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/taxRate/info`,
    method: 'get'
  })
}

// 渠道码保存税率
export const postTaxRateSave = (data) => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/taxRate/save`,
    method: 'post',
    data
  })
}

// 获取佣金明细
export const postChannelManageDetail = (data) => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/detail`,
    method: 'post',
    data
  })
}

// 获取佣金明细导出
export const postChannelManageExport = (data) => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/export`,
    method: 'post',
    data
  })
}

// 渠道码保存说明配置
export const postChannelManageInstructionSave = (data) => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/instruction/save`,
    method: 'post',
    data
  })
}

// 获取渠道码说明配置
export const getChannelManageInstructionInfo = (params) => {
  return request({
    // 本地配置
    // url: 'http://192.168.31.207:37579/channelManage/page',
    // 发布配置
    url: `${env.ferryUrl}/channelManage/instruction/info`,
    method: 'get',
    params
  })
}
